import '@/common/utils/sentry';
import '@/common/requests/application-local';
import '@/common/styles/tailwind.css';

import React, { useEffect } from 'react';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

import { getQueryParam, saveOnStorage, setSessionStorage } from '@/common/utils';
import { MOBILE_SESSION_KEY, ONBOARDING_SESSION_KEY } from '@/common/constants';
import { i18nInit } from '@/common/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false
    }
  },
});

import { HomePage } from '@/pages/home';

const App = () => {

  useEffect(() => {
    const localeStorage = localStorage.getItem('i18nextLng');
    const locale =  getQueryParam('locale') || localeStorage || 'pt-BR';
    const sessionKey = getQueryParam(ONBOARDING_SESSION_KEY);
    const openInMobileKey = getQueryParam('mobile');

    i18nInit(locale).then(() => {
      if (locale && locale !== localeStorage) {
        saveOnStorage({ key: 'i18nextLng',  value: locale });
      }
    });

    if (openInMobileKey) {
      setSessionStorage(MOBILE_SESSION_KEY, openInMobileKey === 'true' ? 'true' : 'false');
    }

    if (sessionKey) {
      setSessionStorage(ONBOARDING_SESSION_KEY, sessionKey);

      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState(null, '', cleanUrl);
    }
  }, []);

  return (
    <div className="app-idverify">
      <QueryClientProvider client={queryClient}>
        <HomePage />
      </QueryClientProvider>
    </div>
  );
};

export default App;
